import React, { memo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';

import ContainerDimensions from '@/components/Base/ContainerDimensions';
import ResponsiveMenu from '@/components/Pages/CompanyPage/ResponsiveMenu';

import {
  Link,
  LinkIcon,
  LinkOption,
  LinkOptionItem,
  ListItem,
} from './ResponsiveMenuWrapper.styles';

const MOBILE_MIN_WIDTH = 320;

function ResponsiveMenuWrapper({ menu = null }) {
  const { formatMessage } = useIntl();

  const isMobile = useMediaQuery({ minWidth: MOBILE_MIN_WIDTH });

  const renderLink = useCallback(
    ({ item, ref = () => {} }) => (
      <ListItem key={item.link} active={item.link === 'cards'} ref={ref}>
        <Link href={item.link} title={item.name}>
          {item.name}
        </Link>
      </ListItem>
    ),
    []
  );

  const renderHiddenLink = useCallback(
    ({ item, ...props }) => (
      <LinkOptionItem key={item.link} {...props}>
        <LinkOption
          href={item.link}
          title={item.name}
          active={item.link === 'cards'}
        >
          {item.name}
        </LinkOption>
      </LinkOptionItem>
    ),
    []
  );

  const renderMoreBtn = useCallback(
    ({ toggle, ref }) => {
      const moreTitle = formatMessage({ id: 'company.links.more' });

      return (
        <ListItem>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link
            as="button"
            type="button"
            title={moreTitle}
            ref={ref}
            onTouchEnd={toggle}
          >
            {moreTitle}
            <LinkIcon name="arrow" />
          </Link>
        </ListItem>
      );
    },
    [formatMessage]
  );

  if (!isMobile) return null;

  return (
    <ContainerDimensions>
      {({ width }) => (
        <ResponsiveMenu
          items={menu}
          containerWidth={width}
          renderLink={renderLink}
          renderHiddenLink={renderHiddenLink}
          renderMoreBtn={renderMoreBtn}
          defaultItemsCount={100}
        />
      )}
    </ContainerDimensions>
  );
}

ResponsiveMenuWrapper.propTypes = {
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      link: PropTypes.string,
    })
  ),
};

export default memo(ResponsiveMenuWrapper);
